<template>
    <component :is="directiveComponent" v-if="directiveComponent" :data="data" :message-id="messageId" :line-idx="lineIdx" />
</template>

<script setup lang="ts">
import { computed } from "vue";

import { resolveDirective, type UiDirectiveAction, type UiDirectiveFlags } from "../uiDirectiveRegistry";

type UiDirectiveRendererProps = UiDirectiveFlags & {
    data: UiDirectiveAction;
    messageId: number;
    lineIdx: number;
};

const props = defineProps<UiDirectiveRendererProps>();

const directiveComponent = computed(() => {
    return resolveDirective(props.data.action_name, props);
});
</script>
